import buildUUID from '../utils/buildUUID.js'

class Polygon {
  constructor(obj){
    const { id, url, name, isFill, color, opacity, outline, outlineColor, outlineOpacity, outlineWidth, clampToGround, highlight, isFillHL, opacityHL, colorHL, outlineHL, outlineOpacityHL, outlineWidthHL, outlineColorHL, isLabel, content, fontSize, fontStyleC, fontColor, fontOpacity, distanceDisplayCondition, maxDistance, minDistance, crs, flyTo} = obj
    this._id = id ? id : buildUUID()
    this._url = url ? url : ''
    this._name = name ? name : 'polygon'
    this._highlight = highlight || false
    this._highlightOptions = {
      type:'click',
      opacity: isFillHL && (opacityHL !== null ) ? opacityHL : 0.0,
      color: isFillHL && colorHL ? colorHL : '#3388ff',
      outline: outlineHL || false,
      outlineOpacity: outlineOpacityHL !== null ? outlineOpacityHL : 1.0,
      outlineWidth: outlineWidthHL !== null ? outlineWidthHL : 1.0,
      outlineColor: outlineColorHL ? outlineColorHL : '#ffffff'
    }
    this._isLabel = isLabel || false
    this._labelOptions = {
      text: content ?  content : '标注',
      position: '{center}',
      font_size: fontSize !== null ? fontSize : 1.0,
      font_family: fontStyleC ? fontStyleC : '宋体',
      color: fontColor ? fontColor : '#ffffff',
      opacity: fontOpacity !== null ? fontOpacity : 1.0,
      distanceDisplayCondition: distanceDisplayCondition || false,
      distanceDisplayCondition_far: maxDistance !== null ? maxDistance : 9999999999999,
      distanceDisplayCondition_near: minDistance !== null ? minDistance : 1.0
    }
    this._styleOptions = {
      color: isFill && color ? color : '#ff0000',
      opacity: opacity !== null ? opacity : 1.0, // 判断opacity是否为null或undefined（防止为0被判断为false的情况）
      outline: outline || false,
      outlineColor: outlineColor ? outlineColor : '#00ff00',
      outlineOpacity: outlineOpacity !== null ? outlineOpacity : 1.0,
      outlineWidth: outlineWidth !== null ? outlineWidth : 1.0,
      clampToGround: clampToGround || false,
      highlight: this._highlight ? this._highlightOptions : {},
      label: this._isLabel ? this._labelOptions : {}
    }
    this._symbol = {
      type:"polygonC",
      styleOptions:this._styleOptions
    }
    this._crs = crs ? crs : 'EPSG:4326'
    this._flyTo = flyTo ? flyTo : false
    // 需要传给mars3d.layer.GeoJsonLayer的对象
    this._initObj = {
      id: this._id,
      url: this._url,
      name: this._name,
      symbol: this._symbol,
      crs: this._crs,
      flyTo: this._flyTo
    }
  }
}

/**
 * 在地图上渲染图层
 * @param {*} map 
 */
Polygon.prototype.addToMap = function(map){
  console.log('执行addToMap!!!')
  var geojsonLayer = new mars3d.layer.GeoJsonLayer(this._initObj);
  map.addLayer(geojsonLayer);
}

export default Polygon